import { createSelector } from 'reselect';
import { getSuggestedItemsOptions } from 'store/suggested-items/selectors';
import { TYPE, FILTER_KEYS } from './fixtures';

export const getProjectItems = ({ projectItems }) => projectItems.data.map((item) => ({
  ...item,
  images: item.images?.sort((a, b) => {
    if(a.created_at === b.created_at) {
      return a?.id > b?.id ? 1 : a?.id < b?.id ? -1 : 0;
    }

    return a?.created_at > b?.created_at ? 1 : a?.created_at < b?.created_at ? -1 : 0;
  }),
}));
export const getProjectItemsLoadingState = ({ projectItems }) => projectItems.loading;
export const getProjectItemsFilters = ({ projectItems }) => projectItems.filters;
export const getSelectedProjectItems = ({ projectItemsActions }) => projectItemsActions.selectedIds;
export const getOpenedProjectItem = ({ projectItemsActions }) => projectItemsActions.openedItemId;

export const getItemById = (id) => createSelector(
  getProjectItems,
  (items) => items.find((item) => item.id === id),
);

export const getSelectedItemTypeIds = createSelector(
  getProjectItems,
  getSelectedProjectItems,
  (items, ids) => items
    .filter(({ id }) => ids.includes(id))
    .map(({ id }) => id),
);

export const getSelectedItemTypeNames = createSelector(
  getProjectItems,
  getSelectedItemTypeIds,
  (items, ids) => items
    .filter(({ id }) => ids.includes(id))
    .map(({ title }) => title),
);

export const getSelectedSetTypeIds = createSelector(
  getProjectItems,
  getSelectedProjectItems,
  (items, ids) => items
    .filter(({ type, id }) => type === TYPE.SET && ids.includes(id))
    .map(({ id }) => id),
);

export const getSelectedSetTypeNames = createSelector(
  getProjectItems,
  getSelectedSetTypeIds,
  (items, ids) => items
    .filter(({ id }) => ids.includes(id))
    .map(({ title }) => title),
);

export const getSelectedItems = createSelector(
  getProjectItems,
  getSelectedProjectItems,
  (items, ids) => items
    .filter(({ id }) => ids.includes(id)),
);

export const getQueryArray = createSelector(
  getProjectItemsFilters,
  // getCategoriesLabelMap,
  // getManufacturersLabelMap,
  // getStoragesLabelMap,
  ({
    [FILTER_KEYS.PAGE]: page,
    [FILTER_KEYS.PER_PAGE]: perPage,
    // [FILTER_KEYS.TYPE]: itemTtpe,
    [FILTER_KEYS.HAS_MORE]: hasMore,
    [FILTER_KEYS.SORT_DIRECTION]: sortDirection,
    ...queryParams
    // eslint-disable-next-line no-shadow,max-len
  }) => Object.keys(queryParams).reduce((result, type) => {
    switch (type) {
    default: {
      return result;
    }
    }
  }, []),
);

export const getSuggestedProjectItemsOptions = createSelector(
  getQueryArray,
  getSuggestedItemsOptions,
  (selectedQueryItems = [], suggestedQueryItems = []) => {
    const existingIds = selectedQueryItems.map(({ value }) => value);

    return suggestedQueryItems.filter((item) => !existingIds.includes(item.value));
  },
);
